import "./src/styles/global.css";

export const onInitialClientRender = () => {
  setTimeout(function() {
    document.getElementsByClassName('loading')[0].remove()
  }, 2000)
}